import { style } from "@vanilla-extract/css";

export const pitchUnitStyles = style({
  display: "flex",
  flexDirection: "column",
});
